module.exports = __webpack_public_path__ + "img/20190605160608QQ截图20190603170124.56ea6ccf.png";